import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import MyImage from '../../Assets/Images/MyImage.jpg';
import './Sidebar.css';

const Sidebar = () => {
    useEffect(() => {
        AOS.init();
    }, [])
    return (
        <div className='sidebar'>
            <div class="sidebar-img" data-aos="fade-right" data-aos-duration="2000">
                <img src={MyImage} alt="" />
            </div>
        </div>
    );
};

export default Sidebar;